import React, { useEffect, useState } from 'react';
import { supabase } from './lib/supabase';
import { LangProvider } from './lib/lang';
import Login from './pages/Login';
import CaseView from './pages/CaseView';

export default function App() {
  const [session, setSession] = useState(undefined); // undefined = loading

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setSession(session));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (session === undefined) return null; // brief loading

  return (
    <LangProvider>
      {session ? <CaseView /> : <Login />}
    </LangProvider>
  );
}

